var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Container',[_c('v-card',{staticClass:"pa-5",attrs:{"elevation":"5","height":"100%"}},[_c('Cards')],1),(_vm.notesDialog)?_c('NotesDialog',{attrs:{"component":this}}):_vm._e(),(_vm.certificateDialog)?_c('CertificateDialog',{attrs:{"component":this}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }